export const REMINDER_COUNT = {
  init: 0,
  show: 1,
  close: 2,
}

export const DELAY_TO_FETCH_IN_MILLISECONDS = 1000
export const REFETCH_INTERVAL_IN_MILLISECONDS = 10 * 1000
